import { action, flow, makeObservable, observable } from 'mobx';
import { ApiResponse, GlobalStore } from '@roc/feature-app-core';
import { RevenueRecognitionService } from '../services/revenueRecognitionService';
import { SelectOption } from "@roc/ui";
import { REVENUE_RECOGNITION_MODULES } from '../utils/constants';
import { MonthFilter, ReveneuRecognitionModules } from '../types/types';
import { getFirstDayOfCurrentMonth } from '../utils/utils';
import { downloadDocument } from '@roc/feature-utils';

export class RevenueRecognitionStore {
  globalStore: GlobalStore;
  service: RevenueRecognitionService;
  selectedModule: SelectOption;
  parameter: any = null;
  months: MonthFilter[] = [];
  exportingReport: boolean = false;


  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.service = new RevenueRecognitionService();
    this.selectedModule = REVENUE_RECOGNITION_MODULES.find(module => module.value === ReveneuRecognitionModules.MONTHLY_TRADE_MODULE);
    this.setParam(getFirstDayOfCurrentMonth());
    makeObservable(this, {
      selectedModule: observable,
      setSelectedModule: action,
      parameter: observable,
      setParam: action,
      months: observable,
      getMonths: flow,
      exportDashboardData: flow,
      exportingReport: observable,
    });
  };

  *getMonths() {
    try {
      const response: ApiResponse = yield this.service.getMonths();
      this.months = response.data.data.map(value => (
        { label: value.label, value: value.value }
      ));
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while fetching filters.',
      });
    }
  }

  *exportDashboardData() {
    try {
      this.exportingReport = true;
      this.globalStore.notificationStore.showInfoNotification({
        message: 'The report is being generated. Please wait...',
      });
      const response: ApiResponse = yield this.service.exportDashboardData(this.selectedModule.value, this.parameter)
      this.exportingReport = false;
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'The report has been generated successfully.',
      });
      downloadDocument(response.data, response.headers, 'download', `${this.selectedModule.value}_REPORT.xlsx`);
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while exporting revenue recognition report.',
      });
      this.exportingReport = false;
    }
  };

  setSelectedModule(module: SelectOption) {
    this.selectedModule = REVENUE_RECOGNITION_MODULES.find(m => m.value === module);
  }

  setParam(value: any) {
    this.parameter = value;
  }
}
